import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

/**
 * Waitinglist Dialog Component
 * Props:
 *   open (bool): whether dialog is open
 *   onClose (func): called when dialog is canceled/closed
 *   onSubmit (func): called with email when submitted and valid
 */
export default function Waitinglist({ open, onClose, onSubmit }) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleSubmit = () => {
    if (!email.match(/^\S+@\S+\.\S+$/)) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    setEmailError("");
    if (onSubmit) onSubmit(email);
    setEmail("");
  };

  const handleCancel = () => {
    setEmail("");
    setEmailError("");
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: 28, mt: 1 }}>
        Join the Waiting List
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Enter your email and be the first to get full access when we launch!
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          type="email"
          fullWidth
          placeholder="Your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          error={!!emailError}
          helperText={emailError}
          sx={{ mb: 2 }}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mb: 1, borderRadius: 2 }}
          onClick={handleSubmit}
        >
          Notify Me
        </Button>
        <Button
          onClick={handleCancel}
          color="primary"
          sx={{ textDecoration: 'underline'}}
        >
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
}
